import PageDefauleTemplate from "../../components/Common/PageDefauleTemplate";
import DetailAnalyticsComponent from "../../components/LearningAnalysisPage/DetailAnalyticsComponent";

const DetailAnalyticsPage = () => {
  return (
    <>
      <PageDefauleTemplate pageName="학습 분석">
        <DetailAnalyticsComponent />
      </PageDefauleTemplate>
    </>
  );
};
export default DetailAnalyticsPage;
